import { Svg1CSVG } from '@sbercloud/uikit-product-icons';

export { Svg1CSVG as OneC, Svg1CSVG as OneCSVG };
